import { useEffect, lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import MobileTabBar from "@/components/MobileTabBar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";








import RoleGuard from "@/components/RoleGuard";
import DashboardLayout from "@/components/DashboardLayout";
// Admin















// Productor









// Comprador






import {
    CompradorPedidosPage,
    CompradorEnviosPage,
} from "@/pages/comprador/CompradorComingPages";
// Transportista




import {
    TransportistaOfertasPage,
    TransportistaAsignadasPage,
    TransportistaEnTransitoPage,
    TransportistaEntregadasPage,
    TransportistaGananciasPage,
} from "@/pages/transportista/TransportistaComingPages";
// Shared



// Other
import ImpersonationBanner from "@/components/ImpersonationBanner";













import { PERSONAL_DASHBOARD_ENABLED } from "@/lib/sniimAlerts";
import DemoBadge from "@/components/DemoBadge";

const MarketplacePage = lazy(() => import("@/pages/MarketplacePage"));
const ProductDetailPage = lazy(() => import("@/pages/ProductDetailPage"));
const PublishPage = lazy(() => import("@/pages/PublishHubPage"));
const OfferTransportPage = lazy(() => import("@/pages/OfferTransportPage"));
const LoginPage = lazy(() => import("@/pages/LoginPage"));
const RegisterPage = lazy(() => import("@/pages/RegisterPage"));
const ForgotPasswordPage = lazy(() => import("@/pages/ForgotPasswordPage"));
const ResetPasswordPage = lazy(() => import("@/pages/ResetPasswordPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));
const SupportPage = lazy(() => import("@/pages/SupportPage"));
const AdminDashboardPage = lazy(() => import("@/pages/dashboards/AdminDashboardPage"));
const AdminUsersPage = lazy(() => import("@/pages/admin/AdminUsersPage"));
const AdminUserDetailPage = lazy(() => import("@/pages/admin/AdminUserDetailPage"));
const AdminProductsPage = lazy(() => import("@/pages/admin/AdminProductsPage"));
const AdminRequestsPage = lazy(() => import("@/pages/admin/AdminRequestsPage"));
const AdminLoadsPage = lazy(() => import("@/pages/admin/AdminLoadsPage"));
const AdminVerificationsPage = lazy(() => import("@/pages/admin/AdminVerificationsPage"));
const AdminAuditPage = lazy(() => import("@/pages/admin/AdminAuditPage"));
const AdminPreciosPage = lazy(() => import("@/pages/admin/AdminPreciosPage"));
const AdminCatalogImagesPage = lazy(() => import("@/pages/admin/AdminCatalogImagesPage"));
const AdminManageImagesPage = lazy(() => import("@/pages/admin/AdminManageImagesPage"));
const AdminSettingsPage = lazy(() => import("@/pages/admin/AdminSettingsPage"));
const AdminCatalogPage = lazy(() => import("@/pages/admin/AdminCatalogPage"));
const AdminLocationsPage = lazy(() => import("@/pages/admin/AdminLocationsPage"));
const AdminMessagesPage = lazy(() => import("@/pages/admin/AdminMessagesPage"));
const ProductorResumenPage = lazy(() => import("@/pages/productor/ProductorResumenPage"));
const ProductorProductosPage = lazy(() => import("@/pages/productor/ProductorProductosPage"));
const ProductorSolicitudesPage = lazy(() => import("@/pages/productor/ProductorSolicitudesPage"));
const ProductorOfertasPage = lazy(() => import("@/pages/productor/ProductorOfertasPage"));
const ProductorPedidosPage = lazy(() => import("@/pages/productor/ProductorPedidosPage"));
const ProductorVentasPage = lazy(() => import("@/pages/productor/ProductorVentasPage"));
const ProductorEnviosPage = lazy(() => import("@/pages/productor/ProductorEnviosPage"));
const ProductorGananciasPage = lazy(() => import("@/pages/productor/ProductorGananciasPage"));
const ProductorNewProductPage = lazy(() => import("@/pages/productor/ProductorNewProductPage"));
const CompradorResumenPage = lazy(() => import("@/pages/comprador/CompradorResumenPage"));
const CompradorSolicitudesPage = lazy(() => import("@/pages/comprador/CompradorSolicitudesPage"));
const CompradorOfertasPage = lazy(() => import("@/pages/comprador/CompradorOfertasPage"));
const CompradorFavoritosPage = lazy(() => import("@/pages/comprador/CompradorFavoritosPage"));
const CompradorComprasPage = lazy(() => import("@/pages/comprador/CompradorComprasPage"));
const CompradorGastosPage = lazy(() => import("@/pages/comprador/CompradorGastosPage"));
const TransportistaResumenPage = lazy(() => import("@/pages/transportista/TransportistaResumenPage"));
const AvailableLoadsPage = lazy(() => import("@/pages/transportista/AvailableLoadsPage"));
const TransportistaVehiculosPage = lazy(() => import("@/pages/transportista/TransportistaVehiculosPage"));
const TransportistaConductoresPage = lazy(() => import("@/pages/transportista/TransportistaConductoresPage"));
const ResenasPage = lazy(() => import("@/pages/shared/ResenasPage"));
const PerfilPage = lazy(() => import("@/pages/shared/PerfilPage"));
const MessagesPage = lazy(() => import("@/pages/MessagesPage"));
const UnifiedAccountPage = lazy(() => import("@/pages/UnifiedAccountPage"));
const DashboardPage = lazy(() => import("@/pages/DashboardPage"));
const DirectoryPage = lazy(() => import("@/pages/DirectoryPage"));
const BuyerRequestsPage = lazy(() => import("@/pages/BuyerRequestsPage"));
const AdminPage = lazy(() => import("@/pages/AdminPage"));
const ProfilePage = lazy(() => import("@/pages/ProfilePage"));
const LegalPage = lazy(() => import("@/pages/LegalPage"));
const PlansPage = lazy(() => import("@/pages/PlansPage"));
const PreciosAgropecuariosPage = lazy(() => import("@/pages/PreciosAgropecuariosPage"));
const PrecioProductoDetailPage = lazy(() => import("@/pages/PrecioProductoDetailPage"));
const BillingPage = lazy(() => import("@/pages/BillingPage"));
const CatalogImageAttributionPage = lazy(() => import("@/pages/CatalogImageAttributionPage"));
const OfficialMarketDataPage = lazy(() => import("@/pages/OfficialMarketDataPage"));
const MisPreciosPage = lazy(() => import("@/pages/MisPreciosPage"));

function App() {
    // Update <title> and meta description
    useEffect(() => {
        document.title = "CampoDirecto — Del productor al comprador, sin intermediarios";
        const desc = "Marketplace agrícola nacional de México. Compre y venda ganado, frutas, verduras, granos, forrajes y maquinaria directo con productores verificados. Preparado para mayoreo y exportación.";
        let meta = document.querySelector('meta[name="description"]');
        if (!meta) { meta = document.createElement("meta"); meta.setAttribute("name", "description"); document.head.appendChild(meta); }
        meta.setAttribute("content", desc);
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <DemoBadge />
                    <ImpersonationBanner />
                    <Navbar />
                    <MobileTabBar />
                    <main className="pb-20 md:pb-0">
                        <Suspense fallback={<div role="status" className="container-page py-10 text-sm text-muted-foreground">Cargando pantalla…</div>}>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/marketplace" element={<MarketplacePage />} />
                            <Route path="/precios-agropecuarios" element={<Navigate to="/marketplace" replace />} />
                            <Route path="/precios-agropecuarios/:slug" element={<Navigate to="/marketplace" replace />} />
                            <Route path="/mis-precios" element={<Navigate to="/mi-cuenta" replace />} />
                            <Route path="/mi-mercado" element={<Navigate to="/mi-cuenta" replace />} />
                            <Route path="/mensajes" element={<RoleGuard allow={["productor", "comprador", "transportista", "exportador", "proveedor", "admin"]}><MessagesPage /></RoleGuard>} />
                            <Route path="/mensajes/:conversationId" element={<RoleGuard allow={["productor", "comprador", "transportista", "exportador", "proveedor", "admin"]}><MessagesPage /></RoleGuard>} />
                            <Route path="/produccion-siap" element={<Navigate to="/marketplace" replace />} />
                            <Route path="/precios-profeco" element={<Navigate to="/marketplace" replace />} />
                            <Route path="/atribucion-imagenes" element={<CatalogImageAttributionPage />} />
                            <Route path="/producto/:id" element={<ProductDetailPage />} />
                            <Route path="/publicar" element={<PublishPage />} />
                            <Route path="/ofrecer-transporte" element={<OfferTransportPage />} />
                            <Route path="/ingresar" element={<LoginPage />} />
                            <Route path="/registro" element={<RegisterPage />} />
                            <Route path="/olvide-contrasena" element={<ForgotPasswordPage />} />
                            <Route path="/restablecer-contrasena" element={<ResetPasswordPage />} />
                            <Route path="/dashboard" element={<Navigate to="/mi-cuenta" replace />} />
                        <Route path="/mi-cuenta" element={<RoleGuard allow={["comprador","productor","transportista","exportador","proveedor","admin"]}><UnifiedAccountPage /></RoleGuard>} />
                            <Route path="/directorio/:role" element={<DirectoryPage />} />
                            <Route path="/solicitudes" element={<BuyerRequestsPage />} />

                            {/* Admin */}
                            <Route path="/admin" element={<RoleGuard allow={["admin"]}><AdminDashboardPage /></RoleGuard>} />
                            <Route path="/admin/usuarios" element={<RoleGuard allow={["admin"]}><AdminUsersPage /></RoleGuard>} />
                            <Route path="/admin/usuarios/:userId" element={<RoleGuard allow={["admin"]}><AdminUserDetailPage /></RoleGuard>} />
                            <Route path="/admin/productos" element={<RoleGuard allow={["admin"]}><AdminProductsPage /></RoleGuard>} />
                            <Route path="/admin/solicitudes" element={<RoleGuard allow={["admin"]}><AdminRequestsPage /></RoleGuard>} />
                            <Route path="/admin/cargas" element={<RoleGuard allow={["admin"]}><AdminLoadsPage /></RoleGuard>} />
                            <Route path="/admin/verificaciones" element={<RoleGuard allow={["admin"]}><AdminVerificationsPage /></RoleGuard>} />
                            <Route path="/admin/catalogo-productos" element={<RoleGuard allow={["admin"]}><AdminCatalogPage /></RoleGuard>} />
                            <Route path="/admin/catalogo-ubicaciones" element={<RoleGuard allow={["admin"]}><AdminLocationsPage /></RoleGuard>} />
                            <Route path="/admin/auditoria" element={<RoleGuard allow={["admin"]}><AdminAuditPage /></RoleGuard>} />
                            <Route path="/admin/precios-agropecuarios" element={<RoleGuard allow={["admin"]}><AdminPreciosPage /></RoleGuard>} />
                            <Route path="/admin/imagenes-catalogo" element={<RoleGuard allow={["admin"]}><AdminCatalogImagesPage /></RoleGuard>} />
                            <Route path="/admin/administrar-imagenes" element={<RoleGuard allow={["admin"]}><AdminManageImagesPage /></RoleGuard>} />
                            <Route path="/admin/configuracion" element={<RoleGuard allow={["admin"]}><AdminSettingsPage /></RoleGuard>} />
                            <Route path="/admin/mensajes" element={<RoleGuard allow={["admin"]}><AdminMessagesPage /></RoleGuard>} />
                            <Route path="/admin/legacy" element={<RoleGuard allow={["admin"]}><AdminPage /></RoleGuard>} />

                            {/* Productor — nested routes under a shared shell */}
                            <Route path="/productor/productos/nuevo" element={<RoleGuard allow={["productor"]}><ProductorNewProductPage /></RoleGuard>} />
                            <Route path="/productor" element={<RoleGuard allow={["productor"]}><DashboardLayout /></RoleGuard>}>
                                <Route index element={<ProductorResumenPage />} />
                                <Route path="productos" element={<ProductorProductosPage />} />
                                <Route path="crear" element={<ProductorNewProductPage />} />
                                <Route path="solicitudes" element={<ProductorSolicitudesPage />} />
                                <Route path="ofertas" element={<ProductorOfertasPage />} />
                                <Route path="pedidos" element={<ProductorPedidosPage />} />
                                <Route path="ventas" element={<ProductorVentasPage />} />
                                <Route path="envios" element={<ProductorEnviosPage />} />
                                <Route path="ganancias" element={<ProductorGananciasPage />} />
                                <Route path="mensajes" element={<Navigate to="/mensajes" replace />} />
                                <Route path="resenas" element={<ResenasPage eyebrow="Reseñas del productor" testIdPrefix="productor" />} />
                                <Route path="perfil" element={<PerfilPage eyebrow="Cuenta del productor" testIdPrefix="productor-perfil" />} />
                                <Route path="*" element={<ProductorResumenPage />} />
                            </Route>

                            {/* Comprador — nested routes under a shared shell */}
                            <Route path="/comprador" element={<RoleGuard allow={["comprador", "exportador"]}><DashboardLayout /></RoleGuard>}>
                                <Route index element={<CompradorResumenPage />} />
                                <Route path="solicitudes" element={<CompradorSolicitudesPage />} />
                                <Route path="ofertas" element={<CompradorOfertasPage />} />
                                <Route path="pedidos" element={<CompradorPedidosPage />} />
                                <Route path="compras" element={<CompradorComprasPage />} />
                                <Route path="envios" element={<CompradorEnviosPage />} />
                                <Route path="gastos" element={<CompradorGastosPage />} />
                                <Route path="favoritos" element={<CompradorFavoritosPage />} />
                                <Route path="mensajes" element={<Navigate to="/mensajes" replace />} />
                                <Route path="resenas" element={<ResenasPage eyebrow="Reseñas del comprador" testIdPrefix="comprador" />} />
                                <Route path="perfil" element={<PerfilPage eyebrow="Cuenta del comprador" testIdPrefix="comprador-perfil" />} />
                                <Route path="*" element={<CompradorResumenPage />} />
                            </Route>

                            {/* Transportista — nested routes under a shared shell */}
                            <Route path="/transportista" element={<RoleGuard allow={["transportista"]}><DashboardLayout /></RoleGuard>}>
                                <Route index element={<TransportistaResumenPage />} />
                                <Route path="cargas" element={<AvailableLoadsPage />} />
                                <Route path="cargas-disponibles" element={<AvailableLoadsPage />} />
                                <Route path="ofertas" element={<TransportistaOfertasPage />} />
                                <Route path="asignadas" element={<TransportistaAsignadasPage />} />
                                <Route path="en-transito" element={<TransportistaEnTransitoPage />} />
                                <Route path="entregadas" element={<TransportistaEntregadasPage />} />
                                <Route path="ganancias" element={<TransportistaGananciasPage />} />
                                <Route path="vehiculos" element={<TransportistaVehiculosPage />} />
                                <Route path="conductores" element={<TransportistaConductoresPage />} />
                                <Route path="mensajes" element={<Navigate to="/mensajes" replace />} />
                                <Route path="resenas" element={<ResenasPage eyebrow="Reseñas del transportista" testIdPrefix="transportista" />} />
                                <Route path="perfil" element={<PerfilPage eyebrow="Cuenta del transportista" testIdPrefix="transportista-perfil" />} />
                                <Route path="*" element={<TransportistaResumenPage />} />
                            </Route>

                            <Route path="/perfil/:id" element={<ProfilePage />} />
                            <Route path="/planes" element={<Navigate to="/marketplace" replace />} />
                            <Route path="/facturacion" element={<Navigate to="/mi-cuenta" replace />} />
                            <Route path="/soporte" element={<SupportPage />} />
                            <Route path="/legal" element={<LegalPage />} />
                            <Route path="/legal/:slug" element={<LegalPage />} />
                            <Route path="*" element={<NotFoundPage />} />
                        </Routes>
                        </Suspense>
                    </main>
                    <Footer />
                    <Toaster richColors position="top-right" />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
